import React from "react";

export const Banner = () => {
  return (
    <div className="bg-black max-h-screen p-12 relative">
      <div className="flex flex-col md:flex-row md:justify-between md:mb-20 gap-4 md:gap-6 lg:gap-10 px-10 justify-center items-center">
        <div className="flex sm:w-[70%] md:w-[48%] w-full">
          <img src="/banner.png" className="flex w-full" alt="banner" />
        </div>

        <div className="flex flex-col w-full md:w-1/2 md:justify-center">
          <img
            src="/idialogo.svg"
            className="w-[80px] md:w-[15%]"
            alt="idia logo"
          />
          <p className="text-5xl md:text-5xl lg:text-6xl 2xl:text-7xl text-white mb-60 mt-4 md:my-6 lg:my-8 font-syne font-bold">
            Think.
            <br />
            Fast.
            <br />
            Innovate.
          </p>
        </div>
      </div>
      <div className="w-[80%] md:ml-[5%] flex absolute -translate-y-[40%] lg:-translate-y-3/5 z-10 !bg-white rounded-3xl shadow-lg ">
        <div className="py-6 px-10">
          <div className="flex flex-col md:flex-row  gap-4 justify-between">
            <p className="flex text-xl lg:text-2xl 2xl:text-3xl font-bold items-center text-center md:text-start md:w-3/5 md:mr-20">
              Welcome to Idia Corporation Pty. brLtd,a startup with a unique
              collection of cutting-edge software products.
            </p>

            <div className="max-w-2/5 flex justify-center items-center">
              <img src="/feature.svg" className="w-full" alt="features svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// className="flex md:absolute lg:-bottom-64 p-4 lg:left-[50%] transform md:-translate-y-1/2 z-10 !bg-white rounded-3xl shadow-lg border border-red-500"
